import { render, staticRenderFns } from "./manageAgency.vue?vue&type=template&id=0ca42bac&scoped=true"
import script from "./manageAgency.vue?vue&type=script&lang=js"
export * from "./manageAgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca42bac",
  null
  
)

export default component.exports